module.exports = __webpack_public_path__ + "img/jsh_img.a8283434.png";